import React from 'react';
import './index.scss';

const DeliveryCardPlaceholder = () => (
    <div className="loading-card">
        <div className="image-placeholder" />
        <div className="seller-placeholder">
            <div className="seller-image" />
            <div className="seller-info">
                <div className="skeleton-row" />
                <div className="skeleton-row" />
            </div>
        </div>
        <footer />
    </div>
);

export default DeliveryCardPlaceholder;
